import { useEffect, useState } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { AnimatePresence, motion } from "framer-motion";
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare, faClose } from '@fortawesome/free-solid-svg-icons';

import { APPMODE, URL_STRAPI, API_TOKEN_STRAPI, oP } from '../core.js'

import './MainHeader.css'

import logo_main from '../assets/pictures/logos/ToN-25-Logo-oT-light-long.webp'

import Cookies from 'universal-cookie'
const cookies = new Cookies()

const anim_header1 = {
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.96, y: 20, transition: { duration: 0.5 } },
}

const anim_banner1 = {
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.4 } },
    hidden: { opacity: 0, scale: 1, y: -15, transition: { duration: 0.4 } },
}


const toastVariants = {
    hidden: {
        y: -100,
        opacity: 0,
        scale: 0.9,
    },
    visible: {
        y: [-100, 10, -5, 0],
        scale: [0.9, 1.05, 0.98, 1],
        opacity: [0, 1, 1, 1],
        transition: {
            duration: 0.6,
            ease: 'easeOut',
            times: [0, 0.4, 0.7, 1]
        },
    },
    exit: {
        y: [0, -10, -100],
        scale: [1, 0.95, 0.8],
        opacity: [1, 0.5, 0],
        transition: {
            duration: 0.3,
            ease: 'easeOut',
            times: [0, 0.4, 1]
        },
    }
};

const containerStyle = {
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '14px 24px',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '999px',
    fontSize: '14px',
    fontFamily: 'sans-serif',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
    zIndex: 9999,
};


export default function MainHeader(props) {

    const isFunnel = props.funnel === true
    const [showBanner, setShowBanner] = useState(false);
    const [bannerContent, setBannerContent] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const dismissedUntil = parseInt(cookies.get('banner_closed_until') || '0');
        const now = Date.now();

        if (now > dismissedUntil) {
            setShowBanner(true);
        }
    }, []);

    const handleToastClose = () => {
        setShowBanner(false);
        const fiveMinutesFromNow = Date.now() + 5 * 60 * 1000;

        cookies.set('banner_closed_until', fiveMinutesFromNow.toString(), {
            path: '/',
            maxAge: 5 * 60 + 5, // Cookie lebt etwas länger als die Sperrfrist
        });
    };

    const fetchLatestActiveBanner = async () => {
        try {
            const res = await axios.get(`${URL_STRAPI}/api/header-banner-infos`, {
                params: {
                    'filters[active][$eq]': true,
                    'sort': 'publishedAt:desc',
                    'pagination[limit]': 1,
                    'populate': '*', // falls Relationen oder Bilder enthalten sind
                },
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
            });

            return res.data.data[0];
        } catch (err) {
            console.error('Fehler beim Laden der Header Banner:', err.message || err);
            return null;
            // throw err; 
            // oder: return []; wenn du leere Liste willst statt Exception
        }
    };

    useEffect(() => {
        fetchLatestActiveBanner().then((content) => { setBannerContent(content) });

    }, [])

    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileMenuOpen]);

    let selsite = props.selectedsite
    function setSelCN(lsite) {
        return (lsite == selsite) ? "mainheader_link selsite" : "mainheader_link";
    }
    function closeMobileMenu() {
        setMobileMenuOpen(false);
    }

    return (
        <div>
            <AnimatePresence>

                {(0 == 1 || isFunnel) ? <div></div> : (bannerContent != null && showBanner == true) &&

                    <motion.div
                        // variants={anim_banner1}
                        variants={toastVariants}
                        initial={(props.disableanimation != true) ? 'hidden' : 'visible'}
                        exit='exit'
                        className='bannerInfo'
                        animate='visible'
                        // style={containerStyle}
                        style={{ backgroundColor: (bannerContent.type == "warn" ? "var(--ci_color_warn)" : "var(--ci_color_primary)") }}
                    >
                        <div className='banner_closebtn' title='Für 5 Minuten ausblenden' onClick={() => handleToastClose()} > <FontAwesomeIcon icon={faClose} /></div>
                        <div className='banner_text'>
                            {(bannerContent.link != null) ? <span onClick={() => oP(bannerContent.link)}>{bannerContent.text}</span> : <span>{bannerContent.text}</span>}


                            {/* {(bannerContent.link != null) ? <span>&nbsp;<a href={bannerContent.link} target='_blank' className='bannerLink'><FontAwesomeIcon icon={faRightLong} /> HIER</a></span> : <div></div>} */}
                        </div>

                        {(bannerContent.link != null) ? <span>&nbsp;<a href={bannerContent.link} target='_blank' rel='noopener noreferrer' aria-label={bannerContent.text || 'Mehr erfahren'} className='bannerLink'><FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a></span> : <div></div>}
                        {/* </div> */}
                    </motion.div>
                }
            </AnimatePresence>



            {
                (0 == 1) ? <div></div> : (APPMODE == "pre") ?
                    <div className='DEVinfo'>
                        🛠️ VORABVERSION 🛠️
                    </div> : (APPMODE == "dev") ?
                        <>
                            <div className='DEVinfo' >
                                🛠️ ACHTUNG: ENTWICKLUNGSVERSION 🛠️
                            </div>
                            <div class="bottommarquee">
                                <div class="track">
                                    <span>DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV – DEV</span>
                                </div>
                            </div>
                        </> : (APPMODE == "local") ?
                            // <div class="repeating-bar" aria-hidden="true"><span>LOCAL – LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL – LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL - LOCAL-</span></div>
                            <div class="marquee">
                                <div class="track">
                                    <span>LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – LOCAL – </span>
                                </div>
                            </div>
                            : <div></div>
            }

            <motion.div
                variants={anim_header1}
                initial={(props.disableanimation != true) ? 'hidden' : 'visible'}
                exit='hidden'
                whileInView='visible'
                viewport={{ once: false }}
                className={
                    'mainheader_div noselect' +
                    (isFunnel ? ' mainheader_div-funnel' : '') +
                    (((1 == 1 && APPMODE != "prod" && APPMODE != "local") ||
                        (!isFunnel && bannerContent != null && showBanner == true))
                        ? ' mainheader_banner_margin'
                        : '')
                }
            // style={{ marginTop: ((1 == 1 && APPMODE != "prod" && APPMODE != "local") || (bannerContent != null && showBanner == true)) ? '80px' : '50px' }}
            >
                <div className={'mainheader_funnel_inner' + (isFunnel ? ' mainheader_funnel_inner-active' : '')}>
                    <a href='/' aria-label='ToNetwork – zur Startseite' className='mainheader_logolink'>
                        <img alt='Logo von ToNetwork' className='mainheader_logo' src={logo_main}></img>
                    </a>

                </div>

                {!isFunnel && (
                    <div className='mainheader_links_desktop'>
                        <Link to='/about' className={setSelCN("about")}>Über uns</Link>
                        <Link to='/news' className={setSelCN("news")}>News</Link>
                        <Link to='/services' className={setSelCN("services")}>Leistungen</Link>
                        <Link to='/pricing' className={setSelCN("pricing")}>Preise</Link>
                        <Link to='/projects' className={setSelCN("projects")}>Projekte</Link>
                        <Link to='/support' className={setSelCN("support")}>Kontakt</Link>
                    </div>
                )}

                {!isFunnel && (
                    <button
                        className={'mainheader_burger ' + (mobileMenuOpen ? 'open' : '')}
                        aria-label='Menü öffnen'
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                )}
            </motion.div>

            <AnimatePresence>
                {!isFunnel && mobileMenuOpen && (
                    <motion.div
                        className='mainheader_mobile_menu_overlay'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={closeMobileMenu}
                    >
                        <motion.div
                            className='mainheader_mobile_menu'
                            initial={{ opacity: 0, y: -20, scale: 0.96 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: -20, scale: 0.96 }}
                            transition={{ duration: 0.25 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Link to='/about' className={setSelCN("about")} onClick={closeMobileMenu}>Über uns</Link>
                            <Link to='/news' className={setSelCN("news")} onClick={closeMobileMenu}>News</Link>
                            <Link to='/services' className={setSelCN("services")} onClick={closeMobileMenu}>Leistungen</Link>
                            <Link to='/pricing' className={setSelCN("pricing")} onClick={closeMobileMenu}>Preise</Link>
                            <Link to='/projects' className={setSelCN("projects")} onClick={closeMobileMenu}>Projekte</Link>
                            <Link to='/support' className={setSelCN("support")} onClick={closeMobileMenu}>Kontakt</Link>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className='header_spacer'></div>

        </div >
    )
}